import { Route, Routes } from "react-router-dom";
import ExternalsCaseAllDataPage from "../components/_Pages/ExternalsPages/ExternalsAllDataPage/ExternalsCaseAllDataPage";
import CasePaidTaskPage from "../components/_Pages/CasePaidTaskPage/CasePaidTaskPage";
import ExternalsCasePage from "../components/_Pages/ExternalsPages/ExternalsCasePage/ExternalsCasePage";
import React from "react";
import CaseRelatedActions from "../components/Case/CaseRelatedActions/CaseRelatedActions";
import { CallProvider } from "../provider/CallProvider";
import { DrawerProvider } from "../provider/DrawerProvider";
import CaseRouteProvider from "../provider/CaseRouteProvider";

const ExternalCaseRoutes = () => {
  return (
    <CaseRouteProvider>
      <DrawerProvider>
        <CallProvider>
          <CaseRelatedActions />

          <Routes>
            <Route path={"/"} element={<ExternalsCasePage />} />
            <Route path={"/alle-daten"} element={<ExternalsCaseAllDataPage />} />
            <Route path={"/ausschreibung/:paidTaskId"} element={<CasePaidTaskPage />} />
          </Routes>
        </CallProvider>
      </DrawerProvider>
    </CaseRouteProvider>
  );
};

export default ExternalCaseRoutes;
